export function createMoltenBundleScriptElement (
  position: 'top' | 'bottom',
  previewBrand: string,
  cdnUri: string,
  isPreviewBundle: boolean
): HTMLScriptElement {
  const previewUrl = `https://adctrl.emsmobile.de/molten/preview/${previewBrand}/MoltenBundle.${position}.js`
  const productionUrl = `${cdnUri}/moltenBundles/${previewBrand}/MoltenBundle.${position}.js`

  const s = document.createElement('script')
  s.type = 'text/javascript'
  s.async = true
  s.src = isPreviewBundle ? previewUrl : productionUrl
  s.dataset.vmid = `molten-bundle-${position}`
  return s
}

export function appendMoltenBundleScript (
  position: 'top' | 'bottom',
  previewBrand: string,
  cdnUri: string,
  isPreviewBundle: boolean
): void {
  const scriptElement = createMoltenBundleScriptElement(position, previewBrand, cdnUri, isPreviewBundle)

  if (position === 'top') {
    document.head.appendChild(scriptElement)
  } else {
    document.body.appendChild(scriptElement)
  }
}
